import { useCallback, useMemo } from 'react';
import getDealerAddresses from '../../api/services/getDealerAddresses';
import SelectWithFetch from './SelectWithFetch';

// label приходит с бэка готовой строкой — «Kia DOSCAR, ул. Елебекова, 10/1».
// Менеджеру нужен адрес, а не только название точки.
const formatOption = (item) => ({ value: item.id, label: item.label });

/**
 * @param {number} typeId — назначение точки: 3 сервис (по умолчанию), 1 тест-драйв.
 * @param {number} markId — марка записи, когда она известна заранее (карточка
 *   уже созданной записи). В формах, где марку выбирают тут же, поле объявляют
 *   с dependency: 'mark' и марка приезжает в dependantValue.
 */
const SelectServiceAddress = ({
  typeId,
  markId,
  dependantValue,
  dependencyAccessor = (obj) => obj,
  ...props
}) => {
  const mark = useMemo(
    () => markId ?? dependencyAccessor(dependantValue),
    [markId, dependantValue, dependencyAccessor]
  );
  const fetch = useCallback(() => getDealerAddresses({ typeId, markId: mark }), [typeId, mark]);

  return <SelectWithFetch fetch={fetch} formatOption={formatOption} resetKey={mark} {...props} />;
};

export default SelectServiceAddress;
